import { css } from '@emotion/react'

export default css`
    .ant-dropdown-menu a,
    .ant-dropdown-menu a:hover {
        text-decoration: none;
    }
`
